module.exports = __webpack_public_path__ + "static/img/off-2p.4d8287f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/newHome/village/off-2p.png
// module id = zzkK
// module chunks = 1